export enum ClientPackageChapterName {
    WEALTH_OVERVIEW_ASSETS_LIABILITIES = 'WEALTH_OVERVIEW_ASSETS_LIABILITIES',
    EVENTS_0 = 'EVENTS',
    EVENTS_1 = 'EVENTS_1',
    EVENTS_2 = 'EVENTS_2',
    PROJECTION = 'PROJECTION',
    CASHFLOW = 'CASHFLOW',
    CASHFLOW2 = 'CASHFLOW2',
    ROADMAP = 'ROADMAP',
    INCOME_EXPENSE = 'INCOME_EXPENSE',
    FAMILY_TREE = 'FAMILY_TREE',
    LIQUIDITY = 'LIQUIDITY',
    APPENDIX = 'APPENDIX',
}
